import { Base } from '@studiometa/js-toolkit';
import Zoom from 'js-image-zoom';

/**
 * Class ImageZoom
 *key @extends Base
 */
export default class ImageZoom extends Base {
  static config = {
    name: 'ImageZoom',
  };

  /**
   * Create zoom effect on image
   * @returns {void}
   */
  mounted() {
    const options = {
      zoomPosition: 'original',
      offset: { vertical: 0, horizontal: 10 },
    };

    Zoom(this.$el, options);
  }

  /**
   * Close single post and go back to home
   * @param  {Object} e
   * @returns {void}
   */
  keyed(e) {
    if (e.ESC) {
      // window.taxi.navigateTo('/');
      this.simulateClick(document.querySelector('.back-btn'));
    }
  }

  /**
   * Simulate click on back btn
   * @param  {Object} elem btn
   * @returns {void}
   */
  simulateClick(elem) {
    const evt = new MouseEvent('click', {
      bubbles: true,
      cancelable: true,
      view: window,
    });
    /* eslint-disable-next-line no-unused-vars */
    const canceled = !elem.dispatchEvent(evt);
  }
}
